module.exports = __webpack_public_path__ + "images/bbcd544b84939d0bff09e8669ba311c6-The National Blacks in Travel and Tourism Collaborative.jpg";